export default "/images/vendor/flag-icon-css/flags/1x1/al.svg?40be1a31ef7b848a1be7cfecc9a3c8d6";